export const w3auth = () => ({
    // Base Auth
    email: () => ({
        login: () => `/email_password/login`,
    }),
    magicLink: () => `/magic_link`,
    token: () => ({
        refresh: () => `/token/refresh`,
    }),

    // SSO
    apple: () => ({
        auth: () => `/apple`,
        login: () => `/apple/login`,
    }),
    discord: () => ({
        auth: () => `/discord`,
        login: () => `/discord/login`,
    }),
    google: () => ({
        auth: () => `/google`,
        login: () => `/google/login`,
    }),
    twitter: () => ({
        auth: () => `/twitter`,
        login: () => `/twitter/login`,
    }),
});
